import eventType, { SseEvent } from '@/constants/eventType'
import { useSseStore } from '@/store/sse'

let source: EventSource | null = null

const EVENTS = Object.values(eventType) as SseEvent[]

export function startSse() {
  if (source) return source

  const url = import.meta.env.VITE_EVENTS_URL
  if (!url) {
    console.warn('[SSE] Missing VITE_EVENTS_URL')
    return null
  }

  const sseStore = useSseStore()
  source = new EventSource(url, { withCredentials: true })

  const handler = (ev: MessageEvent) => {
    try {
      // If your backend sometimes sends plain strings, guard JSON.parse.
      const data = safeJsonParse(ev.data)
      const type = ev.type as SseEvent
      sseStore.$onEvent(type, data)
    } catch (err) {
      console.error('[SSE] Failed to handle event', ev.type, err)
    }
  }

  for (const t of EVENTS) {
    source.addEventListener(t, handler)
  }

  source.addEventListener('open', () => {
    console.info('[SSE] connected')
  })

  source.addEventListener('error', (e) => {
    // EventSource will auto-retry by default.
    console.warn('[SSE] error', e)
  })

  // tidy up if user closes tab
  window.addEventListener('beforeunload', stopSse)

  return source
}

/** Stop/close SSE (idempotent). */
export function stopSse() {
  try {
    source?.close()
  } finally {
    source = null
  }
}

function safeJsonParse(raw: string) {
  try {
    return JSON.parse(raw)
  } catch {
    return raw // allow non-JSON payloads
  }
}
